export const NAV_LINKS = [
  { href: "/#idea", label: "Hello" },
  { href: "/#ecosystem", label: "Ecosystem" },
  { href: "/#philosophy", label: "Philosophy" },
  { href: "/#for-who", label: "For Who" },
  { href: "/#manifesto", label: "Manifesto" },
  { href: "/#journal", label: "Journal" },
];
